import { createAction } from '@reduxjs/toolkit'

import type { UpdatePayment, WithPlanId } from './types'

export const UpgradePlanActions = {
  redirect: createAction<WithPlanId>('REDIRECT_TO_AUTH'),
  updatePayment: createAction<UpdatePayment>('UPDATE_PAYMENT'),
  upgrade: createAction<WithPlanId>('UPGRADE_PLAN'),
}
